const ImageLoader = {

    load(image, src, type) {
        if (image.length && src.length) {
            ImageLoader
                .preload(src)
                .then(() => ImageLoader.insert(src, image, type))
                .catch(() => console.log('Error on loading image. Image path: ' + src));
        }
    },

    preload(src) {
        return new Promise((success, error) => {
            const image = new Image();
            image.onload = success;
            image.onerror = error;
            image.src = src;
        });
    },
    insert(src, element, type) {
        // todo: maybe some other types?
        if (type === "background") {
            ImageLoader.setBackground(src, element);
        } else {
            ImageLoader.setSrc(src, element);
        }
    },
    setBackground(src, element) {
        element.css({
            'background-image': 'url("' + src + '")'
        });
    },
    setSrc(src, element) {
        element.attr('src', src);
    },
    preloadDefaultImages() {
        $('[data-image-preload]').each(function () {
            const element = $(this),
                src = element.data('image-preload'),
                type = element.data('image-type');

            element.removeAttr('data-image-preload')
                .removeAttr('data-image-type');

            if (element.length && src.length) {
                ImageLoader
                    .preload(src)
                    .then(() => ImageLoader.insert(src, element, type))
                    .catch(() => console.log('Error on loading image. Image path: ' + src));
            }
        });
    }

};

export default ImageLoader;